'use client';

import { usePathname } from 'next/navigation';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import BackToTop from '@/components/BackToTop';

export default function MainLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isAuthPage = pathname === '/login' || pathname === '/register';
  const isDashboardPage =
    pathname === '/dashboard' ||
    pathname.startsWith('/dashboard/') ||
    pathname === '/fr/dashboard' ||
    pathname.startsWith('/fr/dashboard/');

  // Logic for Tool Detail Page: /(fr/)? [profession] / [subcategory] / [tool]
  const toolDetailRegex = /^\/(?:fr\/)?[^/]+\/[^/]+\/[^/]+\/?$/;
  const isToolDetailPage = toolDetailRegex.test(pathname);

  // Tools listing, about, contact, etc. should also probably be consistent with marketing theme
  const isMarketingUtilityPage = 
    pathname === '/tools' || pathname === '/fr/tools' ||
    pathname === '/about' || pathname === '/fr/about' ||
    pathname === '/contact' || pathname === '/fr/contact' ||
    pathname === '/newsletter' || pathname === '/fr/newsletter';

  const isThemeAware = isDashboardPage || isToolDetailPage;
  const isForcedDark = !isThemeAware && !isAuthPage;

  if (isAuthPage || isDashboardPage) {
    return <>{children}</>;
  }

  const content = (
    <div className="relative flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <BackToTop />
    </div>
  );

  if (isForcedDark) {
    return (
      <div className="dark bg-background text-foreground transition-colors duration-300">
        {content}
      </div>
    );
  }

  return content;
}
